<div class="scrollToSelector" [class.scrollToSelector___hidden]="isInView()">
  <div (click)="scrollToSelector()" [class]="iconClassName()"></div>
</div>
